import { render, staticRenderFns } from "./editHelp.vue?vue&type=template&id=c1c46ff2&scoped=true&"
import script from "./editHelp.vue?vue&type=script&lang=js&"
export * from "./editHelp.vue?vue&type=script&lang=js&"
import style0 from "./editHelp.vue?vue&type=style&index=0&id=c1c46ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c46ff2",
  null
  
)

export default component.exports